export const RESERVED_ATTRIBUTES = {
  default: null,
  compute: null,
  activate: null,
  type: null,
  message: null,
  force: null,
  validators: null,
  asset: null,
  create: null,
  save: null,
  saveAs: null,
  drop: null,
  to: null,
  map: null,
  mapAs: null,
  setter: null,
  getter: null,
  formatter: null,
  readonly: false,
  disabled: false,
  hidden: false,
  required: false,
  empty: null,
  available: null,
  watch: null,
  follow: null,
  init: null,
  state: null,
  deps: null,
  needs: null,
  factors: null,
  catch: null,
}
